import DE1 from "../assets/svg/DE1.svg";
import DE2 from "../assets/svg/DE2.svg";
import DE3 from "../assets/svg/DE3.svg";
import DE4 from "../assets/svg/DE4.svg";
import DE5 from "../assets/svg/DE5.svg";

export default [
  {
    title: "Traceable Ingredients",
    image: DE1,
  },
  {
    title: "Non-GMO",
    image: DE2,
  },
  {
    title: "Third Party Tested",
    image: DE3,
  },
  {
    title: "Vegan",
    image: DE4,
  },
  {
    title: "No Artificial Flavors or Synthetic Fillers",
    image: DE5,
  },
];
